var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "toast"
    }
  }, [_vm.show ? _c('div', {
    staticClass: "u-toast"
  }, [_vm.isMask ? _c('div', {
    staticClass: "toast-mask",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "toast-content"
  }, [_vm._v(_vm._s(_vm.message))])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };